import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../../components/Forms/PresetsTextField'

const SiteBuild = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <PresetsTextField
        label="Site Build"
        value={opsPlan?.siteBuild}
        suggestionPath="opsPlan.siteBuild"
        suggestionLabel="Site build notes from templates"
        setValue={(newValue) => {
          setOpsPlan((prev) => ({
            ...prev,
            siteBuild: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        fullWidth
        multiline
        minRows={2}
        autoComplete="off"
        name="opsplan-sitebuild"
        InputLabelProps={{
          shrink: !!opsPlan?.siteBuild,
        }}
      />
    </Grid>
  )
}

export default React.memo(SiteBuild)
